import { zeichenMasse, zeichenStriche } from '../lib/agentOsZeichen'

/**
 * Das AgentOS-Zeichen „Werkstück“ als SVG (Kopie aus dem Portal). Die
 * Striche tragen die Markenfarben; der Punkt nimmt `currentColor`, damit er
 * auf dunklem Grund hell und auf hellem dunkel steht.
 */
export function AgentOsZeichen({ className, striche = 8, title }: { className?: string; striche?: 6 | 8; title?: string }) {
  const masse = zeichenMasse(striche)
  return (
    <svg className={className} viewBox="0 0 100 100" role={title ? 'img' : undefined} aria-hidden={title ? undefined : true} aria-label={title}>
      <g strokeWidth={masse.breite} strokeLinecap="round">
        {zeichenStriche(striche).map((s) => (
          <line key={s.farbe} x1={s.x1} y1={s.y1} x2={s.x2} y2={s.y2} stroke={s.farbe} />
        ))}
      </g>
      <circle cx="50" cy="50" r={masse.punkt} fill="currentColor" />
    </svg>
  )
}
